import React from "react";
import PropTypes from "prop-types";

const CarSubHeading = ({ lead }) => {
    const { variant, rto, registrationState } = lead;
    let code = registrationState.displayText;
    if (rto && rto.id) {
        code = rto.displayText;
    }
    const carSubtitle =  [
        variant.displayText,
        code
    ].join(", ");

    return <React.Fragment>{carSubtitle}</React.Fragment>;
};

CarSubHeading.propTypes = {
    variants: PropTypes.object.isRequired,
    registrationStates: PropTypes.object.isRequired,
    lead: PropTypes.object.isRequired
};

export default CarSubHeading;
